<template>
  <a v-if="action" :href="href" :target="target">
    <slot />
  </a>
</template>

<script>
export default {
  props: {
    action: { type: Object, required: true }
  },
  data() {
    return {
      href: "javascript:void(0)",
      target: "_self"
    }
  },
  created() {
    this.initAction();
  },
  methods: {
    initAction() {
      let { type, route, data } = this.action;
      if (type == "outer_link") {
        this.href = data.path;
        this.target = "_blank";
      } else if (type == "inner_link") {
        let { pageKey, param } = route;
        switch(pageKey) {
          case "cms":
            if (param == "home_hair") this.href = "/hair-rituel";
            else if (param == "home") this.href = "/";
            else this.href = `/landing?key=${param}`;
            break;
          case "category":
            this.href = `/category/${param}`;
            break;
          case "product":
            this.href = `/detail?id=${param}`;
            break;
          case "trial_by_post":
            this.href = `/trialconfirm?id=${param}`;
            break;
          case "home":
            this.href = `/`;
            break;
          default:
            this.href = `/`;
            console.warn(`[Xink.vue@initAction]: `, this.action);
            break;
        }
      } else {
        console.log(`链接=（类型：${type}, 地址：${route}, 参数：${JSON.stringify(data)}）`);
      }
    }
  }
}
</script>

<style>

</style>